import { Component, OnInit, Input, AfterViewChecked } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { AppService } from "../../../../services/app.service";
import { MasterService } from "../../../../services/master.service";
import { Subject } from "rxjs";
import { AjaxService } from "../../../../../../core/services/ajax.service";
import { Http } from "@angular/http";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "app-customer-detail",
    templateUrl: "./customer-detail.component.html",
    styleUrls: ["./customer-detail.component.scss"]
})
export class CustomerDetailComponent implements OnInit {
    @Input() parent: any;

formGroup: FormGroup;
formGroupErrors: any;

translations: any;
postalCodeList: any = [];
pcFilterCtrl: FormControl = new FormControl();
/** Subject that emits when the component has been destroyed. */
private _onDestroy = new Subject<void>();
searchFlag: boolean = true;
invalidForm = true;
postalCodeError: string = "";

pcRequired = false;
constructor(
    private formBuilder: FormBuilder,
    public appService: AppService,
    private masterService: MasterService,
    private http: Http,
    private _ajaxService: AjaxService
) {
    this.appService.showLoading();
    this.setPageTranslations();

    this.formGroupErrors = {
        C_Name: {},
        C_Address: {},
        City: {},
        Region: {},
        Canton:{},
        Country: {},
        C_HouseNo: {},
        C_Email: {}
    };   
  
}

ngOnInit() {     
    this.loadFormGroup();
    //    this.pcFilterCtrl.valueChanges
    //        .debounceTime(400)
    //        .pipe(takeUntil(this._onDestroy))
    //        .subscribe(() => {
    //        this.filterPC();
    //    });  
    //this.bindPostalCodes();
    this.appService.hideLoading();
    if((typeof this.parent.order.Id == 'undefined' || this.parent.order.Id == 0) && this.parent.order['PostalCode'] == ''){       
        this.pcRequired = false;
        this.appService.hideLoading();
    }
    else{
        this.pcFilterCtrl.setValue(this.parent.order['PostalCode']);
    }   

}

bindPostalCodes(search){
    if(search.length > 2){
        var postalCode = typeof this.parent != undefined && typeof this.parent.order != undefined && typeof this.parent.order.C_PostalCodeId != 'undefined' ? this.parent.order.C_PostalCodeId : '0';
        this._ajaxService.GET("Master.svc/postalcodes/34/"+ postalCode + "/0/" + search + "/0").subscribe(response => {
                this.postalCodeList = JSON.parse(response.Data);
        });
    }
}

filterPC() {    
    let search = this.pcFilterCtrl.value;
    if (search && search.length > 0) {

        this._ajaxService
            .GET("Master.svc/generalList/34/" 
                 + (typeof this.parent.order.C_PostalCodeId != 'undefined' ? this.parent.order.C_PostalCodeId : '0') + "/0/"
                 + (!search ? " " : search)+ "/0")
            .subscribe(response => {
            this.postalCodeList = JSON.parse(response.Data);
            //this.pcRequired = this.parent.order.C_PostalCodeId > 0 ? false : true;
            //            if(this.parent.order.C_PostalCodeId > 0
            //               && !this.formGroup.invalid){
            //                if(this.postalCodeList != null){
            //                    this.changePostalCode(this.postalCodeList[0].Id,this.postalCodeList[0].Description,this.postalCodeList[0].Code);           
            //                }
            //                this.appService.setFormValid(false);
            //            }
            //            else{
            //                this.appService.setFormValid(true);
            //                if(this.postalCodeList != null){
            //                    this.changePostalCode(this.postalCodeList[0].Id,this.postalCodeList[0].Description,this.postalCodeList[0].Code);           
            //                }
            //            }
            if(this.postalCodeList != null){
                this.changePostalCode(this.postalCodeList[0].Id,this.postalCodeList[0].Description,this.postalCodeList[0].Code);
                this.pcRequired = false;
                this.appService.setFormValid(false);
                this.postalCodeError = this.translations.msgEnterValidPostalCode;
            }
            else{
                this.pcRequired = true;
                this.appService.setFormValid(true);
                this.postalCodeError = this.translations.msgEnterValidPostalCode;
                this.appService.hideLoading();
            }            
        });
    }else {
        this.parent.order.C_PostalCodeId = 0;
        this.postalCodeList = [];
        this.pcRequired = true;
        if(this.parent.order.C_PostalCodeId > 0
           && !this.formGroup.invalid){
            this.appService.setFormValid(false);
        }
        else{
            this.postalCodeError = this.translations.msgPleaseSelectPostalCode;
            this.appService.setFormValid(true);
        }
        this.appService.hideLoading();
    }
}
setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
}

apiFaillure(error): void {
    this.appService.showDialogue(
    this.translations.hdError,
    this.translations[error]
    );
}
onPCBlur(e){    
    if(this.pcFilterCtrl.value != null && this.pcFilterCtrl.value != ""){
        this.appService.showLoading();
        if(this.parent.order.PostalCode != this.pcFilterCtrl.value.toString().trim()){
            this.parent.order.C_PostalCodeId = 0;
            this.parent.order.City = '';
            this.parent.order.Country = '';
            this.parent.order.Region = '';
            this.parent.order.Canton = '';
            this.filterPC();
        }
    }
    else{
        this.parent.order.C_PostalCodeId = 0;
            this.parent.order.City = '';
            this.parent.order.Country = '';
            this.parent.order.Region = '';
            this.parent.order.Canton = '';
    }
    //this.pcRequired =  this.parent.order.C_PostalCodeId  > 0 ? false : true;
}
onSelectionChanged(e){
    ;
    console.log(e);
}
changePostalCode(pcCodeId,pcDescription,pcCode) {
    ;
    if (this.parent.order.C_PostalCodeId != pcCodeId) {
        this.appService.showLoading();

        this.parent.order.C_PostalCodeId= pcCodeId;

        this.parent.order.PostalCode = pcDescription + ' (' + pcCode + ')';
        this.pcRequired = this.parent.order.C_PostalCodeId > 0 ? false : true;
        this.masterService
            .cccDetail(pcCodeId)
            .subscribe(
            res => this.changePostalCodeSuccess(res),
            error => this.apiFaillure(error)
        );
    }
    if(this.parent.order.C_PostalCodeId > 0
       && !this.formGroup.invalid){
        this.appService.setFormValid(false);
    }
    else{
        this.appService.setFormValid(true);
    }
}

changePostalCodeSuccess(res): void {
    this.appService.hideLoading();
    if (res.Data != null) {
        
        this.parent.order.C_CountryId = "";
        this.parent.order.City = JSON.parse(res.Data)[0]["City"];
        this.parent.order.Country = JSON.parse(res.Data)[0]["Country"];
        this.parent.order.C_CountryId = JSON.parse(res.Data)[0]["CountryId"];
        this.parent.order.Region = JSON.parse(res.Data)[0]["Region"];
        this.parent.order.Canton = JSON.parse(res.Data)[0]["Canton"];
        this.parent.order.IsEU = JSON.parse(res.Data)[0]["IsEU"];

    } else {
        this.apiFaillure(res.Message);
    }
}

loadFormGroup(){
    this.formGroup = this.formBuilder.group({
        C_Name: ["", Validators.required],
        C_Address: ["", Validators.required],
        C_HouseNo: [""],
        // C_Email: ['', [Validators.pattern(/^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/)]],
        // C_Email: ["", Validators.pattern(/^([\w-\.]{1,64}((\[|\()?@(\]|\))?|(\[|\()?at(\]|\))?|(\[|\()?kukac(\]|\))?)[\w-]{1,64}((\[|\()?\.(\]|\))?|(\[|\()?dot(\]|\))?|(\[|\()?pont(\]|\))?)[a-zA-Z]{2,3})$/)],
        C_Email: ['', [Validators.pattern(/^([\w+-.%]+@[\w\-.]+\.[A-Za-z]{2,4};?)+$/)]],
        City: [
            {
                value: "",
                disabled: true
            }
        ],
        Region: [
            {
                value: "",
                disabled: true
            }
        ],
        Canton: [
            {
                value: "",
                disabled: true
            }
        ],
        Country: [
            {
                value: "",
                disabled: true
            }
        ]

    });
    this.formGroup.valueChanges.subscribe(() => {
        this.formGroupErrors = this.appService.onFormValuesChanged(
            this.formGroup,
            this.formGroupErrors
        );
        if(this.parent.order.C_PostalCodeId > 0
           && this.parent.order.C_Address != ""
           && this.parent.order.C_Name != ""
           && !this.formGroup.invalid){
            ;
            this.appService.setFormValid(false);
        }
        else{
            this.appService.setFormValid(true);
        }

    });

}
ngAfterViewChecked(): void {
    /* need _canScrollDown because it triggers even if you enter text in the textarea */

}    
changePostalCodeTab(e,postalCodeId){
    console.log(e.key.toString());
}
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-edit-form/customer-detail/customer-detail.component.ts